module.exports = __webpack_public_path__ + "img/bls-6.d0e31687.png";